import { render, staticRenderFns } from "./tempat_pembayaran.vue?vue&type=template&id=067adbd0&"
import script from "./tempat_pembayaran.vue?vue&type=script&lang=js&"
export * from "./tempat_pembayaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports